<template>
  <!-- <f7-page id="attachment-import"> -->
  <div class="page">
    <!--bottom-toolbar></bottom-toolbar-->
    <div class="page-content">

  		<page-nav-bar currentServiceName="MoneyRoad" subNavTitle="Import Contacts" :returnPreviousPage="isSmartphone"></page-nav-bar>

      <div class="layoutTop"/>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-10 offset-md-1">
            <div class="panel21 panel-default">

              <div class="panel-heading">
                  <h4 class="content-block labelAccordionForm">
                      <f7-icon f7='list_bullet'></f7-icon>
                      Import Beneficiaries
                  </h4>
              </div>

                <form>
                  <div class="form-group row">
                    <div class="col-5 col-sm-2" v-bind:class="colorBottomButton">
                      <label class="button-inner-color fileContainer attachmentImportButtonLength">
                        Choose file
                        <input ref="fileInput" type="file" name="file2" id="file2" class="" @change="onFileChange"></input>
                      </label>
                    </div>
                    <div class="col-7 col-sm-10">
                      <input class="form-control" name="filename" placeholder="Choose file" type="text" v-model="attachmentName" disabled></input>
                    </div>
                  </div>
                </form>
              </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 offset-md-9" v-bind:class="colorBottomButton">
                <button round
                  class="importAttachmentButton button-action firstButtonMarginTop"
                  @click="importAttachment">
                    <f7-icon f7='list_bullet'></f7-icon>
                    <span>Import</span>
                </button>
              </div>
            </div>
            <!-- </f7-list> -->
            <!--<canvas id="pdf-canvas" width="1000" class="hiddenElement"></canvas>-->
            <!-- <div id="pdf-text"></div> -->

            <div class="toolbarPageBottomBlank"></div>

          </div>
        </div>
    </div>
  </div>
  <!-- </f7-page> -->
</template>

<script>

// import {post} from '@/helpers/api'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
// import PDFJS from 'pdfjs-dist'
// import Tesseract from 'tesseract.js'
// import axios from 'axios'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'importAttachement',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      isSmartphone: false,
      tesseract: '',
      typeAttachment: '',
      mimeType: '',
      attachment: '',
      attachmentName: '',
      reference: '',
      newOCRTextData: ''
    }
  },
  created: function () {
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    this.typeAttachment = ''
    this.mimeType = ''
    this.attachment = ''
    this.attachmentName = ''
    this.reference = ''
    this.fileInput = ''
    // this.$refs.fileInput.value = null
  },
  methods: {
    importAttachment: function () {
      let that = this
      if (that.attachment !== '' && that.attachmentName !== '') {
        this.$f7.showPreloader('Importing Contacts')
        that.$engine.contacts
          .importContacts(
            this.typeAttachment,
            that.attachment.split(';')[0].split('/')[1],
            that.attachmentName,
            that.attachment.split(';')[1].substring(7)
          )
          .then(response => {
            that.$f7.closeModal()
            that.$f7.hidePreloader()
            that.status = response.status
            if (response.status === 200) {
              that.typeAttachment = ''
              that.mimeType = ''
              that.attachment = ''
              that.attachmentName = ''
              that.reference = ''
              that.newOCRTextData = ''
              that.$$(that.$$('#file2')[that.$$('#file2').length - 1]).val('')
              // document.getElementById('file2').value = ''
              that.$bus.$emit('refresh-cache-contacts')
              that.$f7.modal({
                title: 'Contacts imported',
                text: '<span class="preloader"></span>'
              })
              setTimeout(function () {
                that.$f7.closeModal()
                // loadPage(that, {url: '/attachments/', force: false, ignoreCache: false})
                loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
                // that.$f7.mainView.router.back()
                // loadPage(that, {url: '/attachments/'})
              }, 2000)
            }
          })
          .catch(error => {
            that.$f7.closeModal()
            that.$f7.hidePreloader()
            this.handleError(error) // mixins errorHandlerMixins
          })
      } else {
        that.$f7.alert('', 'Data missing')
      }
    },
    onFileChange (e) {
      /* eslint-disable no-undef */
      let that = this
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 1000000) {
        that.createImage(files[0])
        that.attachmentName = files[0].name
        that.mimeType = files[0].type
      } else {
        that.$f7.alert('This file has a size of ' + Math.round(files[0].size / 1000) + 'Kb. \n Maximum permited is 1MB', 'Maximum file size exceeded')
      }
      /* eslint-enable no-undef */
    },
    createImage (file) {
      let reader = new FileReader()
      let that = this
      this.$f7.modal({
        title: 'Charging File',
        text: '<span class="preloader"></span>'
      })
      reader.onload = (e) => {
        that.attachment = e.target.result
        that.$f7.closeModal()
      }
      reader.readAsDataURL(file)
    },
    removeImage: function (e) {
      this.attachment = ''
    }
  }
}
</script>
<style scoped>
.fileContainer [type=file] {
    display: none;
    color: white;
}
.fileContainer {
  border: 1px solid #ffd210;
  text-decoration: none;
  text-align: center;
  border-radius: 27px;
  line-height: 25px;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
  padding: 0 10px;
  margin: 0;
  height: 27px;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: inherit;
  cursor: pointer;
  outline: 0;
  width: auto;
  float: right;
}
.attachmentImportButtonLength {
  width: 101px;
  float: left;
}
.progressbar {
  height: 8px;
}
.container {
    width: 100%;
    height: auto;
}
.panel2, .panel21 {
    background: #fcfcfc;
    border: solid 1px #dbdbdb;
    /*margin-bottom: 5%;*/
    padding-bottom: 25px;
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    float: left;
    width: 100%;
    height: auto;
}
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

 .col-md-12 {
    float: right;
    width: 100%;
    padding: 0px;
}
.col-md-4 {
  float: left;
  width: 100%;
  margin: 0px;
}
.inputFileButton {
  float: left;
}
</style>



// WEBPACK FOOTER //
// CMContactsImport.vue?0681d571